import React from 'react'
import FileDropzone from './FileDropzone'
import axiosService from '../../utils/AxiosService'
import { FileEarmarkPlus } from 'react-bootstrap-icons'

const AvatarUploader = ({ url, onDocumentUpload = () => {}, onDocumentUploadFailure = () => {} })  => {
  const uploadAvatar = avatar => {
    const avatarData = new FormData()
    avatarData.append('project_manager[avatar]', avatar[0])

    axiosService.patch(url, avatarData, { headers: { "Content-type": "multipart/form-data" } })
                .then(onDocumentUpload)
                .catch(onDocumentUploadFailure)
  }

  return (
    <FileDropzone uploadFiles={uploadAvatar} icon={<FileEarmarkPlus />} />
   );
}

export default AvatarUploader;
